import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as Utils from '../../commons/utils/Utils';
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Radio,
  FormControlLabel,
  RadioGroup
} from '@material-ui/core';
import { StyledTableCell } from '../../commons/utils/TableStyles';
import Timezone from '../../commons/timezone/Timezone.js';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';

const HistoricoDatosLaboralesGrid = (props) => {
  const [loading, setLoading] = useState(false);
  const [radioValue, setRadioValue] = useState('cecos');
  const [historial, setHistorial] = useState([]);

  const handleChangeRadio = (event) => {
    setRadioValue(event.target.value);
  };

  useEffect(() => {
    if (!props.personaId) {
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await Utils.getData('/personas/' + props.personaId + '/historico-datos-laborales');
        setHistorial(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error(err);
        setHistorial([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [props.personaId]);

  return (
    <div className="card">
      <div className="card-content">
        <div className="card-body">
          <div className="container-fluid mb-1">
            <div className="row dt-icons">
              <div className="col-md-12">
                <RadioGroup row value={radioValue} onChange={handleChangeRadio}>
                  <FormControlLabel
                    value="cecos"
                    label={
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.radio.cecos.label"
                        defaultMessage="CECOs"
                      />
                    }
                    control={<Radio color="default" />}
                  />
                  <FormControlLabel
                    value="transportadora"
                    label={
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.radio.transportadora.label"
                        defaultMessage="Transportadora"
                      />
                    }
                    control={<Radio color="default" />}
                  />
                </RadioGroup>
              </div>
            </div>
          </div>

          {/* Solapa CECOs */}
          {radioValue === 'cecos' && (
            <TableContainer>
              <Table aria-label="historico cecos table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.column_fecha.label"
                        defaultMessage="Fecha"
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.column_ceco_anterior.label"
                        defaultMessage="CECO Anterior"
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.column_ceco_nuevo.label"
                        defaultMessage="CECO Nuevo"
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.column_formulario.label"
                        defaultMessage="Formulario"
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.column_usuario.label"
                        defaultMessage="Usuario"
                      />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <StyledTableCell colSpan={5} align="center">
                        <FormattedMessage id="Cargando" defaultMessage="Cargando" />
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {!loading && historial.length === 0 && (
                    <TableRow>
                      <StyledTableCell colSpan={5} align="center">
                        <FormattedMessage
                          id="personasAbm.historicoDatosLaborales_modal.sin_registros"
                          defaultMessage="Sin registros"
                        />
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {!loading &&
                    historial.map(function(registro, key) {
                      return (
                        <TableRow key={key}>
                          <StyledTableCell align="left">
                            {LocaleFormat.formatDateTime(Timezone.getDateForClient(registro.fecha_hora))}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {registro.centro_costos_anterior ? registro.centro_costos_anterior : '-'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {registro.centro_costos_nuevo ? registro.centro_costos_nuevo : '-'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {registro.formulario_id ? registro.formulario_id : '-'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {registro.usuario ? registro.usuario : '-'}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {/* Solapa Transportadora */}
          {radioValue === 'transportadora' && (
            <TableContainer>
              <Table aria-label="historico transportadora table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.column_fecha.label"
                        defaultMessage="Fecha"
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.column_transportadora_anterior.label"
                        defaultMessage="Transportadora Anterior"
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.column_transportadora_nueva.label"
                        defaultMessage="Transportadora Nueva"
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.column_formulario.label"
                        defaultMessage="Formulario"
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage
                        id="personasAbm.historicoDatosLaborales_modal.column_usuario.label"
                        defaultMessage="Usuario"
                      />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <StyledTableCell colSpan={5} align="center">
                        <FormattedMessage id="Cargando" defaultMessage="Cargando" />
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {!loading && historial.length === 0 && (
                    <TableRow>
                      <StyledTableCell colSpan={5} align="center">
                        <FormattedMessage
                          id="personasAbm.historicoDatosLaborales_modal.sin_registros"
                          defaultMessage="Sin registros"
                        />
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {!loading &&
                    historial.map(function(registro, key) {
                      return (
                        <TableRow key={key}>
                          <StyledTableCell align="left">
                            {LocaleFormat.formatDateTime(Timezone.getDateForClient(registro.fecha_hora))}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {registro.transportadora_anterior ? registro.transportadora_anterior : '-'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {registro.transportadora_nueva ? registro.transportadora_nueva : '-'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {registro.formulario_id ? registro.formulario_id : '-'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {registro.usuario ? registro.usuario : '-'}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    </div>
  );
};

export default HistoricoDatosLaboralesGrid;
